import { render, staticRenderFns } from "./detail-pc.vue?vue&type=template&id=298e4414&scoped=true&"
import script from "./detail-pc.vue?vue&type=script&lang=js&"
export * from "./detail-pc.vue?vue&type=script&lang=js&"
import style0 from "./detail-pc.vue?vue&type=style&index=0&id=298e4414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e4414",
  null
  
)

export default component.exports